import { Text } from '@frontend/design-system';
import { ResourcePill } from '../../components/avatar-pill/resource-pill';
import { WeekdayColumnHeader } from '../../components/weekday-column-header';
import { useCalendarGridStore, useNonReactiveStore } from '../../store/calendar-grid.store';
import { CalendarColumn, CalendarColumnHeaderType } from '../../types';

interface Props {
  columnId: string;
  headerType: CalendarColumnHeaderType;
  groupId: string;
}

export const ColumnHeader = ({ columnId, headerType, groupId }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.getColumnInfo(groupId, columnId));
  const isColumnHeaderClickEnabled = useCalendarGridStore((s) => s.isColumnHeaderClickEnabled);
  const nonReactiveStore = useNonReactiveStore();

  if (!columnInfo) return null;

  const handleClick = isColumnHeaderClickEnabled
    ? () => nonReactiveStore.getState().onColumnHeaderClick?.(columnId, groupId)
    : undefined;

  if (headerType === 'weekday') {
    const { dayOfMonth, name, slotsCount } = columnInfo as CalendarColumn<'weekday'>;
    return <WeekdayColumnHeader dayOfMonth={dayOfMonth} weekday={name} slotsCount={slotsCount} />;
  }

  if (headerType === 'provider') {
    const { name, providerImage, type, count } = columnInfo as CalendarColumn<'provider'>;
    return <ResourcePill name={name} avatarSrc={providerImage} type={type} counter={count} onClick={handleClick} />;
  }

  if (headerType === 'operatory') {
    const { name, operatoryIcon, count } = columnInfo as CalendarColumn<'operatory'>;
    return <ResourcePill name={name} iconName={operatoryIcon} counter={count} onClick={handleClick} />;
  }

  return (
    <Text textAlign='center' onClick={handleClick}>
      {columnInfo.name}
    </Text>
  );
};
